module.exports = __webpack_public_path__ + "media/images/icons/star-outline-7a29aed99ba145cd8adc4c1bc32a0d21.svg";